import ReactDOM from 'react-dom/client';
import './index.css';
import "preline/preline";
import Sidbar from './components/Sidbar';

import Charts from './components/Charts';
import TableStatus from './components/TableStatus';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
      <div>
       
            
            
            <Sidbar/>
         
            
            
             
           
      </div>
);

